import { axiosPrivate } from "./axios";

export const jumbotronByApi = async (payloadData) => {
  let res = await axiosPrivate.get("/frontend/jumbotron", payloadData);
  return res.data;
};
